import { render, staticRenderFns } from "./ShopifyStock.vue?vue&type=template&id=76671fbe&"
import script from "./ShopifyStock.vue?vue&type=script&lang=js&"
export * from "./ShopifyStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopifyStock.vue"
export default component.exports